import { useEffect, useState } from "react";
import { getInlineLoader } from "../Helpers";
import ServiceDetailLayout from "../components/ServiceDetailLayout";
import banner from "../assets/nssf.jpg";
import { IoMdPeople, IoMdWallet, IoMdCheckmarkCircle } from "react-icons/io";
import Footer from "../ones/Footer";
import TestimonialSlider from "../ones/TestimonialSlider";

export default function NSSF() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);

  if (!ready)
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );

  const hero = {
    kicker: "Contribution Compliance",
    title: "NSSF Contributions",
    subtitle: "Employer schedules, uploads, and reconciliations",
    description:
      "We keep employer deductions accurate, upload the monthly schedules on your behalf, and reconcile AP/AR so you stay compliant with Tanzanian social security obligations.",
    image: banner,
    chips: ["Group remittance", "Reconciliation", "Audit ready"],
  };

  const highlights = [
    { icon: <IoMdPeople />, title: "Payroll alignment", detail: "Connect payroll inputs with official NSSF rates and exemptions." },
    { icon: <IoMdWallet />, title: "Secure uploads", detail: "Prepare and upload schedules via TRA/NSSF portals." },
    { icon: <IoMdCheckmarkCircle />, title: "Record transparency", detail: "Archive confirmations and share dashboards for HR." },
  ];

  const timeline = [
    { title: "Data capture", detail: "Collect employee lists, wages, and benefits for accuracy." },
    { title: "Contribution prep", detail: "Apply band ranges, calculate contributions, and reconcile totals." },
    { title: "Submission & proof", detail: "Upload schedules, capture receipt, and keep digital filing copies." },
  ];

  const extra = {
    ctaTitle: "Schedule a compliance review",
    ctaCopy: "We can cover NSSF, TRA, and payroll submissions so you never miss another due date.",
  };

  return (
    <>
      <ServiceDetailLayout hero={hero} highlights={highlights} timeline={timeline} extra={extra} />
      <TestimonialSlider />
      <Footer />
    </>
  );
}
